<template>
    <el-dialog
        :visible="show"
        :title="title"
        top="10vh"
        width="70%"
        max-height="500"
        :close-on-click-modal="false"
        append-to-body
        @close="close"
    >
        <div class="filelist-container">
            <div class="filter-row">
                <div class="filter-row-left">
                    <span class="span-style">{{ $t('filter') }}</span>
                    <div class="filter-item" v-show="getUser.userType === '1'">
                        <div class="filter-label">{{ $t('table_column_lable_milestone') }}</div>
                        <div class="filter-value">
                            <el-cascader
                                class="section-title-cascader"
                                v-model="filter.milestone"
                                :options="milestoneColumns"
                                size="mini"
                                :props="{
                                    value: 'id',
                                    label: 'milestoneName',
                                    children: 'childMilestoneBO'
                                }"
                                clearable
                                @change="onSelectClick"
                            ></el-cascader>
                        </div>
                    </div>
                    <div class="filter-item">
                        <div class="filter-label">{{ $t('fileNameKeyword') }}</div>
                        <div class="filter-value">
                            <el-input v-model="filter.uploadFilename" size="mini" clearable @input="onInputName"></el-input>
                        </div>
                    </div>
                    <div class="filter-item">
                        <div class="filter-value">
                            <el-date-picker
                                v-model="filter.uploadDateRange"
                                type="daterange"
                                range-separator="~"
                                :start-placeholder="$t('file_upload_start_date')"
                                :end-placeholder="$t('file_upload_end_date')"
                                class="search-dateRange"
                                clearable
                                @change="onSelectClick"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="filter-item">
                        <div class="filter-value">
                            <el-select v-model="filter.createBy" :placeholder="$t('UPLOAD_BY')" clearable class="search-uploadBy" @change="onSelectClick">
                                <el-option
                                    v-for="(v, k) in filelist
                                        .map((v) => v.createBy)
                                        .reduce((pre, v, k, arr) => {
                                            !pre.includes(v) ? pre.push(v) : ''
                                            return pre
                                        }, [])"
                                    :key="k"
                                    :label="v"
                                    :value="v"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="filter-row-right">
                    <el-button class="wl-green" size="mini" @click="onReset">{{ $t('COMMON_CLEAR_BTN') }}</el-button>
                </div>
            </div>
            <el-table
                :data="pageData"
                border
                max-height="500"
                @selection-change="onTableSelectChange"
                ref="fileTable"
                :row-class-name="tableRowClassName"
                style="margin-top: 10px;"
            >
                <el-table-column width="65">
                    <template #header>
                        <div>
                            <el-checkbox @change="onAllSelectChange" v-model="calcAllSelect"></el-checkbox>
                            ({{ selectData.length }})
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox @change="(e) => onSelectionChange(e, scope.row)" :value="calcIsChecked(scope.row)"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column width="150" :label="$t('COMMON_ENTITY')" prop="cur.entityName" show-overflow-tooltip></el-table-column>

                <el-table-column
                    :label="$t('DOWNLOAD_FILE_NAME')"
                    header-align="center"
                    min-width="100"
                    show-overflow-tooltip
                    prop="uploadFilename"
                >
                    <template
                      slot-scope="scope"
                    >
                      <span>
                        <svg-icon :icon-name="getUploadFileIcon(scope.row.uploadFilename)" :size="20"></svg-icon>
                        {{scope.row.uploadFilename}}
                      </span>
                    </template>
                </el-table-column>

                <el-table-column
                    v-if="getUser.userType === '1'"
                    :label="$t('table_column_lable_milestone')"
                    header-align="center"
                    min-width="130"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ scope.row.multiMilestoneName }}
                        <span class="forkpmgonly" v-show="scope.row.accessFlag == '0'">{{ $t('for_kpmg_only') }}</span>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('DOWNLOAD_SIZE')" header-align="center" align="center" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.size | fileSize }}
                    </template>
                </el-table-column>

                <el-table-column :label="$t('DOWNLOAD_TIME')" header-align="center" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.lastDownloadDate | formatDateTime }}
                    </template>
                </el-table-column>

                <el-table-column
                    :label="$t('DOWNLOAD_BY')"
                    prop="lastDownloadBy"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                ></el-table-column>

                <el-table-column :label="$t('UPLOAD_TIME')" header-align="center" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.createDate | formatDateTime }}
                    </template>
                </el-table-column>

                <el-table-column
                    :label="$t('UPLOAD_BY')"
                    prop="createBy"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="action" width="70" show-overflow-tooltip align="center" :label="$t('COMMON_DELETE')">
                    <template slot-scope="scope">
                        <!-- 已接受条目不可删除 || 毕马威不可删除客户上传的文件 || 客户也不可删除毕马威上传的文件 -->
                        <i class="el-icon-delete delete" v-if="allowDelete(scope.row)" @click="onDeleteClick(scope.row)" />
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="wl-pagination"
                :total="filelist.length"
                :page-size="pageSize"
                @size-change="onSizeChange"
                :page-sizes="[10, 50, 100]"
                layout="prev, pager, next, sizes, total"
                @current-change="handleCurrentChange"
            >
            </el-pagination>
        </div>
        <template #footer>
            <div class="batch-select-footer">
                <span class="filesize-text file-limit-tip" v-if="mode !== 'export_file_log'">{{ getSizeFormat }}</span>
                <el-button size="mini" @click="close">{{ $t('btn_cancel') }}</el-button>
                <el-button class="wl-green" size="mini" :disabled="selectData.length === 0" @click="onConfirmClick" :loading="loading">{{
                    $t('btn_confirm')
                }}</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import API from '@/api'
import { loading, isIE, dateFormat, formatFileSize } from '@/utils'
import { exportCsv, exportFileLogXls } from '@/utils/exportTable'
import { downloadBatchFiles } from '@/utils/useDownload'
import windowConfig from '@/utils/windowConfig'
import SvgIcon from "@/components/svgIcon/index";
import { getFileIcon } from '../../components/data.js'

export default {
    name: 'SASBatchSelectFile',
    props: {
        filelist: {
            type: Array,
            default: () => []
        },
        show: false,
        mode: '',
        milestoneColumns: []
    },
    components: {
        SvgIcon
    },
    data() {
        return {
            visiableIcon: require('@/assets/img/kpicon-eye-on.svg'),
            unVisiableIcon: require('@/assets/img/kpicon-eye-off.svg'),
            unVisiableEditableIcon: require('@/assets/img/kpicon-eye-disable.svg'),
            pageSize: 10,
            current: 1,
            loading: false,
            selectData: [],
            filter: {
                milestone: [],
                uploadFilename: '',
                uploadDateRange: null,
                createBy: ''
            },
            calcAllSelect: false,
            isEdit: false,
            timer: '',
        }
    },

    mounted() {},
    methods: {
        getUploadFileIcon(filename) {
            return getFileIcon(filename);
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.uploadUserType === '1') {
                return 'kp-update-row'
            }
            return ''
        },
        /**
         * 判断文件是否可以删除
         */
        allowDelete(file) {
            if (file.milestoneRowValue && file.milestoneRowValue.state > 0 && [1, 4].includes(file.milestoneRowValue.state)) {
                return false
            }
            if (this.getUser.userType === '1' && file.uploadUserType === '2') {
                return false
            }
            if (file.uploadUserType === this.getUser.userType || file.createBy === this.getUser.userAccount) {
                return true
            }

            return false
        },
        onAllSelectChange(e) {
            this.selectData = e ? JSON.parse(JSON.stringify(this.filelist)) : []
        },
        onSelectionChange(e, row) {
            if (e) {
                if (this.selectData.findIndex((v) => v.id == row.id) == -1) {
                    this.selectData.push(row)
                }
            } else {
                const findIndex = this.selectData.findIndex((v) => v.id == row.id)
                if (findIndex > -1) {
                    this.selectData.splice(findIndex, 1)
                }
            }
            if (this.selectData.length == this.filelist) {
                this.calcAllSelect = true
            } else {
                this.calcAllSelect = false
            }
        },
        calcIsChecked(row) {
            return !!this.selectData.find((v) => v.id == row.id)
        },
        onSelectClick() {
            this.tableLoading = true
            this.selectData = []
            if (
                this.filter.milestone.length == 0 &&
                this.filter.uploadFilename == '' &&
                (!this.filter.uploadDateRange || this.filter.uploadDateRange.length == 0) &&
                this.filter.createBy == ''
            ) {
                return
            }

            this.selectData = JSON.parse(JSON.stringify(this.filelist))
            if (this.filter.milestone.length == 2) {
                this.selectData = this.selectData.filter((v) => v.milestoneId == this.filter.milestone[1])
            }
            if (this.filter.uploadFilename !== '') {
                this.selectData = this.selectData.filter(
                    (v) => v.uploadFilename.toLowerCase().indexOf(this.filter.uploadFilename.toLowerCase()) > -1
                )
            }
            if (this.filter.uploadDateRange && this.filter.uploadDateRange.length == 2) {
                const start = new Date(this.filter.uploadDateRange[0])
                const end = new Date(this.filter.uploadDateRange[1])
                this.selectData = this.selectData.filter((v) => {
                    const createDateTimestamp = Date.parse(new Date(v.createDate))
                    return (
                        createDateTimestamp >=
                            Date.parse(`${start.getFullYear()}-${start.getMonth() - 0 + 1}-${start.getDate()} 00:00:00`) &&
                        createDateTimestamp <= Date.parse(`${end.getFullYear()}-${end.getMonth() - 0 + 1}-${end.getDate()} 23:59:59`)
                    )
                })
            }
            if (this.filter.createBy !== '') {
                this.selectData = this.selectData.filter((v) => v.createBy == this.filter.createBy)
            }
            setTimeout(() => {
              this.tableLoading = false;
            }, 500);
        },
        onReset() {
            this.filter = {
                milestone: [],
                uploadFilename: '',
                uploadDateRange: null,
                createBy: ''
            }
            this.onAllSelectChange();
        },
        onInputName() {
            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(() => {
                if(this.fileName !== ''){
                    this.onSelectClick();
                }
            }, 500)
        },
        onTableSelectChange(e) {
            this.selectData = e
        },
      
        onConfirmClick() {
            switch (this.mode) {
                case 'batch_download':
                    {
                        const [size] = this.getSize; 
                        if (size > windowConfig.download.size) {
                            this.$confirm(
                                this.$t('largeSizeFileAlertContent', { size: formatFileSize(windowConfig.download.size) }),
                                this.$t('largeSizeFileAlertTitle'),
                                {
                                    distinguishCancelAndClose: true,
                                    showConfirmButton:false,
                                    cancelButtonText: this.$t('btn_ok'),
                                    cancelButtonClass: 'wl-green',
                                }
                            ).then(() => {})
                        } else {
                            this.confirmBatchDownload()
                        }
                    }
                    break

                case 'export_file_log':
                    {
                        this.confirmExportFileLog()
                    }
                    break
            }
        },
        confirmExportFileLog() {
            const header =
                this.getUser.userType === '1'
                    ? [
                          this.$t('TABLE_HEADER_ENTITIES'),
                          this.$t('milestone_file_visible_to_client'),
                          this.$t('DOWNLOAD_FILE_NAME'),
                          this.$t('table_column_lable_milestone'),
                          this.$t('DOWNLOAD_SIZE'),
                          this.$t('DOWNLOAD_TIME'),
                          this.$t('DOWNLOAD_BY'),
                          this.$t('UPLOAD_TIME'),
                          this.$t('UPLOAD_BY')
                      ]
                    : [
                          this.$t('TABLE_HEADER_ENTITIES'),
                          this.$t('DOWNLOAD_FILE_NAME'),
                          this.$t('DOWNLOAD_SIZE'),
                          this.$t('DOWNLOAD_TIME'),
                          this.$t('DOWNLOAD_BY'),
                          this.$t('UPLOAD_TIME'),
                          this.$t('UPLOAD_BY')
                      ]
            exportFileLogXls([
                header,
                ...this.selectData.map((v) =>
                    this.getUser.userType === '1'
                        ? [
                              v.cur.entityName ? v.cur.entityName : '',
                              v.isClientVisible ? 'Y' : 'N',
                              v.uploadFilename ? v.uploadFilename : '',
                              (v.multiMilestoneName ? v.multiMilestoneName : '') + (!v.isEditVisible ? this.$t('for_kpmg_only') : ''),
                              formatFileSize(v.size),
                              dateFormat(new Date(v.lastDownloadDate), 'yyyy-MM-dd hh:mm:ss'),
                              v.lastDownloadBy ? v.lastDownloadBy : '',
                              dateFormat(new Date(v.createDate), 'yyyy-MM-dd hh:mm:ss'),
                              v.createBy ? v.createBy : ''
                          ]
                        : [
                              v.cur.entityName ? v.cur.entityName : '',
                              v.uploadFilename ? v.uploadFilename : '',
                              formatFileSize(v.size),
                              dateFormat(new Date(v.lastDownloadDate), 'yyyy-MM-dd hh:mm:ss'),
                              v.lastDownloadBy ? v.lastDownloadBy : '',
                              dateFormat(new Date(v.createDate), 'yyyy-MM-dd hh:mm:ss'),
                              v.createBy ? v.createBy : ''
                          ]
                )
            ],`Statutory Accounts Status _ files records@${dateFormat(new Date(), 'yyyyMMdd')}.xlsx`)
        },
        confirmBatchDownload() {
            const [originalSize] = this.getSize
            if (originalSize > windowConfig.download.size) {
                      this.$confirm(
                          this.$t('largeSizeFileAlertContent', { size: formatFileSize(windowConfig.download.size) }),
                          this.$t('largeSizeFileAlertTitle'),
                          {
                            distinguishCancelAndClose: true,
                            showConfirmButton:false,
                            cancelButtonText: this.$t('btn_ok'),
                            cancelButtonClass: 'wl-green',
                          }
                      )
            } else {
                downloadBatchFiles('/file/free/downloadStatutoryFilesAsZip', {
                fileIdList: this.selectData.map((v) => v.id).join(','),
                siteId: this.getSite.siteId,
                source: 'statutory'
                },originalSize)
            }
            
        },
        handleCurrentChange(val) {
            this.current = val
        },
        onSizeChange(size) {
            this.current = 1
            this.pageSize = size
        },
        calcVisibleIcon(row) {
            if (!row.isEditVisible) {
                return this.unVisiableEditableIcon
            }
            if (row.isEditVisible && row.isClientVisible) {
                return this.visiableIcon
            }
            if (row.isEditVisible && !row.isClientVisible) {
                return this.unVisiableIcon
            }
        },
        close() {
            this.onReset();
            this.$emit('closeBatch', this.isEdit)
            console.log(1111111)
        },
        onDeleteClick(row) {
            this.$confirm(this.$t('sas_delete_file_text'), this.$t('delete_file'), {
                showConfirmButton: true,
                confirmButtonText: this.$t('btn_confirm'),
                confirmButtonClass: 'wl-green',
                showCancelButton: true,
                cancelButtonText: this.$t('comment_reSet'),
                cancelButtonClass: 'cancel-btn',
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
                type: 'warning'
            }).then(() => {
                API.status
                    .deleteFiles({
                        siteId: this.getSite.siteId,
                        fileId: row.id
                    })
                    .then((res) => {
                        if (res.code === '1') {
                            this.$message.success(this.$t('msg_success'))
                            this.filelist.splice(
                                this.filelist.findIndex((v) => v.id === row.id),
                                1
                            )
                            this.isEdit = true
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
            })
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser'
        }),
        pageData() {
            return this.filelist.slice(this.pageSize * (this.current - 1), this.pageSize * (this.current - 1) + this.pageSize)
        },
        title() {
            return {
                batch_download: this.$t('BATCH_DOWNLOAD'),
                export_file_log: this.$t('BATCH_export')
            }[this.mode]
        },
        getSizeFormat() {
            const [originalSize, hasUnknownFileSize] = this.getSize
            const size = formatFileSize(originalSize) || '0B'
            if (hasUnknownFileSize) return `${this.$t('FILE_TOTAL_SIZE_HINT', { size })}`
            return `${this.$t('FILE_SELECTED_SIZE_HINT', { size })}`
        },
        getSize() {
            let size = 0
            let hasUnknownFileSize = false
            this.selectData.forEach((file) => {
                if (!file.size) hasUnknownFileSize = true
                size += parseInt(file.size || 0)
            })
            return [size, hasUnknownFileSize]
        },
    },
    watch: {
        show(v) {
            if (v) {
                this.isEdit = false
                this.selectData = JSON.parse(JSON.stringify(this.filelist))
                this.calcAllSelect = true
            }
        }
    }
}
</script>
<style scoped>
.filelist-container {
}
.visible_to_client-icon {
    width: 15px;
    height: 15px;
    cursor: pointer;
}
.visible_to_client-icon-uneditable {
    cursor: not-allowed;
}
.filename:hover {
    /* text-decoration: underline;
    cursor: pointer;
    color: #3879eb; */
}
.filename .filename-icon {
    color: #3879eb;
    margin-right: 10px;
}
.forkpmgonly {
    color: #bc4c4c;
    font-weight: 600;
}

.filesize-text {
    margin-right: 20px;
}
.filelist-container .filter-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    background: #F3F6FF;
    height: 46px;
    border-radius: 5px;
}
.filelist-container .filter-row .filter-row-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.filelist-container .filter-row .filter-row-left .filter-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.filelist-container .filter-row .filter-row-left .filter-item .filter-label {
    font-size: 12px;
}
.filelist-container .filter-row .filter-row-left .filter-item .filter-value {
    margin-left: 10px;
    margin-right: 10px;
}
.filelist-container .filter-row .filter-row-right {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-right: 10px;
}
.span-style{
    display: flex;
    font-weight: 700;
    font-size: 12px;
    vertical-align: middle;
    margin-left: 10px;
    align-items: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
input[type='number'] {
    -moz-appearance: textfield;
}
::v-deep .el-radio__inner,
::v-deep .el-input__inner {
    border-color: #409eff;
}

::v-deep .el-date-editor .el-range__icon,
::v-deep .el-select .el-input .el-select__caret {
    color: #409eff;
}

::v-deep .el-range-editor--small .el-range-input {
    font-size: 12px;
}
.delete {
    color: #fd349c;
    cursor: pointer;
}
::v-deep .kp-update-row {
    background: #0091da;
    color: #ffffff;
}
::v-deep .kp-update-row:hover {
    color: #93637c;
}
::v-deep .search-dateRange .el-range-input {
    color: #409EFF;
}
::v-deep .el-input--small .el-input__inner {
    color: #409EFF;
}
::v-deep .el-input--mini .el-input__inner {
    color: #409EFF;
}
::v-deep .el-dialog__body {
    padding-top: 5px;
}
</style>
